import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyedropper2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEyedropper2"><Path fillRule="evenodd" clipRule="evenodd" d="M17.0001 1.58588L22.4144 7.00001L16.9144 12.5L18.4144 14L17.0002 15.4142L15.5002 13.9142L8.41421 21H3V15.5858L10.0859 8.49994L8.58594 7.00001L10.0002 5.5858L11.5001 7.08573L17.0001 1.58588ZM14.0859 12.4999L11.5001 9.91415L6.41424 15H11.5858L14.0859 12.4999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEyedropper2;
